import {Injectable} from "@angular/core";

/**
 * Storage for securely storing sensitive data locally.
 * Useful for storing sensitive information such as user credentials or tokens in a secure manner.
 * These values will also be available on the server when performing Server Side Rendering (SSR).
 */
@Injectable()
export abstract class SecureStorageLocal {
    abstract getItem(key: string): Promise<string | null>;
    abstract setItem(key: string, value: string): Promise<void>;
    abstract removeItem(key: string): Promise<void>;
    abstract clear(): Promise<void>;
}
